
export function get<T = any>(input: any, key: string, fallback: T): T {
  return (input?.[key] !== undefined) ? input[key] : fallback;
}

export function getList<T = any>(val: string | T[], delimiter = ','): T[] {
  if (Array.isArray(val)) return val;
  return val.split(delimiter).map(v => v.trim()) as unknown as T[];
}

export function getBool(val: any): boolean {
  if (typeof val === 'boolean') return val;
  if (typeof val === 'string') {
    return ['1', 'true', 'yes'].includes(val.toLowerCase());
  }
  return !!val;
}

export function getNumber(val: any, fallback = 0): number {
  const num = Number(val);
  return isNaN(num) ? fallback : num;
}
